export default __webpack_public_path__ + "static/media/like.329c9371.png";